import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import AddTabContentQuery from '@atlassian/jira-relay/src/__generated__/AddTabContentQuery.graphql';

export const addTabContentEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() => import(/* webpackChunkName: "async-horizontal-nav-add-tab-content" */ './AddTabContent'),
	),
	getPreloadProps: ({ scopeId, first }: { scopeId: string; first: number }) => ({
		queries: {
			mainQuery: {
				parameters: AddTabContentQuery,
				variables: {
					first,
					containerNavigationInput: { scopeId },
				},
				options: {
					fetchPolicy: 'network-only' as const,
				},
			},
		},
	}),
});
